import { NgModule } from "@angular/core";
import { LorenAssetDetailsComponent } from "./components/loren-asset-details/loren-asset-details.component";
import { LorenAssetDetailsResolver } from "./loren-asset-details.resolver";
import { LorenAssetDetailsRoutingModule } from "./loren-asset-details-routing.module";
import { AssetFormComponent } from "../loren-assets/components/asset-form/asset-form.component";
import {
  LorenAssetImageUploaderComponent
} from "./components/loren-asset-image-uploader/loren-asset-image-uploader.component";
import { MatIcon } from "@angular/material/icon";
import { MatButton, MatIconButton } from "@angular/material/button";
import { MatCard } from "@angular/material/card";
import { MatStep, MatStepLabel, MatStepper, MatStepperNext, MatStepperPrevious } from "@angular/material/stepper";
import { ReactiveFormsModule } from "@angular/forms";
import { MatError, MatFormField, MatLabel } from "@angular/material/form-field";
import { TranslocoModule } from "@jsverse/transloco";
import { CdkDrag, CdkDragHandle, CdkDragPlaceholder, CdkDropList } from "@angular/cdk/drag-drop";
import { MatInput } from "@angular/material/input";
import { MatOptgroup, MatOption, MatSelect } from "@angular/material/select";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { AsyncPipe, JsonPipe, KeyValuePipe, NgClass, NgIf } from "@angular/common";
import { MatDivider } from "@angular/material/divider";
import { MatTooltip } from "@angular/material/tooltip";
import { LorenImageModule } from "../../shared/pipes/loren-image/loren-image.module";
import {
  LorenHierarchySelectorModule
} from "../../shared/modules/loren-hierarchy-selector/loren-hierarchy-selector.module";
import {
  LorenAssetLocationSelectionModule
} from "../../shared/modules/loren-asset-location-selection/loren-asset-location-selection.module";
import { LorenPageContentComponent } from "../../shared/modules/loren-page-content/loren-page-content.component";
import { DragItemComponent } from "../../common/drag-item/drag-item.component";
import {
  AssetSensorDialogComponent
} from "../loren-assets/components/asset-sensor-dialog/asset-sensor-dialog.component";
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from "@angular/material/dialog";
import { LorenSharedDirectivesModule } from "../../shared/directives/loren-shared-directives.module";
import { UnstyledButtonDirective } from "../../common/unstyled-button/untyles-button.directive";

@NgModule({
  declarations: [AssetFormComponent, AssetSensorDialogComponent],
  providers: [LorenAssetDetailsComponent, LorenAssetDetailsResolver],
  imports: [LorenAssetDetailsRoutingModule, LorenAssetImageUploaderComponent, MatIcon, MatIconButton, MatCard, MatStepper, MatStep, ReactiveFormsModule, MatFormField, TranslocoModule, CdkDropList, MatLabel, MatInput, MatSelect, MatOptgroup, MatOption, MatAutocompleteModule, NgClass, MatError, MatDivider, MatTooltip, AsyncPipe, LorenImageModule, LorenHierarchySelectorModule, LorenAssetLocationSelectionModule, MatButton, MatStepperNext, MatStepLabel, MatStepperPrevious, CdkDrag, NgIf, KeyValuePipe, LorenPageContentComponent, JsonPipe, CdkDragPlaceholder, CdkDragHandle, DragItemComponent, MatDialogActions, MatDialogContent, MatDialogTitle, MatDialogClose, LorenSharedDirectivesModule, UnstyledButtonDirective],
})
export class LorenAssetDetailsModule {}
